export default "__VITE_ASSET__DhuPeA99__"